<template>
  <div class="green-finance-award">
    <!--  活动 绿色金融奖  -->
    <div class="award-image-container">
      <img class="award-main-image" src="../../assets/mobile/award/award_2026.jpg" alt="2026 Sustainable Development Selection">
      <!-- Clickable overlay for the 立即报名 button -->
      <div
        class="register-button-overlay"
        :class="{ pressed: registerPressed }"
        @click="showModal"
        @mousedown="onRegisterPress"
        @mouseup="onRegisterRelease"
        @mouseleave="onRegisterRelease"
        @touchstart.prevent="onRegisterPress"
        @touchend.prevent="showModal"
      ></div>
    </div>
      
      <div class="modal" v-show="modalVisible">
      <div class="mask"></div>
      <div class="modal-wrap">
        <div class="modal-box">
          <p>请填写以下信息，主办方将于1-3个工作日内发送参评所需材料内容至您的邮箱。</p>
          <div class="form">
            <div class="item">
              <div class="inp-wrap">
                <div class="label">单位名称</div>
                <input :class="{errInp: formErr.companyName}" type="text" v-model="signMsg.companyName">
              </div>
              <p class="err-msg" :style="{opacity: formErr.companyName ? 1 : 0}">{{formErrMsg.companyName}}</p>
            </div>
            <div class="item">
              <div class="inp-wrap">
                <div class="label">联系人</div>
                <input :class="{errInp: formErr.userName}" type="text" v-model="signMsg.userName">
              </div>
              <p class="err-msg" :style="{opacity: formErr.userName ? 1 : 0}">{{formErrMsg.userName}}</p>
            </div>
            <div class="item">
              <div class="inp-wrap">
                <div class="label">联系电话</div>
                <input :class="{errInp: formErr.mobile}" type="text" v-model="signMsg.mobile">
              </div>
              <p class="err-msg" :style="{opacity: formErr.mobile ? 1 : 0}">{{ formErrMsg.mobile }}</p>
            </div>
            <div class="item">
              <div class="inp-wrap">
                <div class="label">邮箱地址</div>
                <input :class="{errInp: formErr.email}" type="text" v-model="signMsg.email">
              </div>
              <p class="err-msg" :style="{opacity: formErr.email ? 1 : 0}">{{formErrMsg.email}}</p>
            </div>
          </div>
          <div
            class="submit-btn"
            :class="{ pressed: submitPressed }"
            @mousedown="onPress"
            @mouseup="onRelease"
            @mouseleave="onRelease"
            @touchstart.prevent="onPress"
            @touchend.prevent="onRelease"
          >提&nbsp;&nbsp;交</div>
        </div>
        <div class="close-btn" @click="hideModal">X</div>
      </div>
    </div>
    <!-- 成功提示弹窗（替换原生 alert） -->
    <div class="tip-modal" v-show="tipVisible">
      <div class="mask" @click="hideTip"></div>
      <div class="tip-wrap">
        <div class="tip-box">
          <div class="tip-title">提示</div>
          <p class="tip-message">{{ tipMessage }}</p>
          <div class="ok-btn" @click="hideTip">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "GreenFinanceAward",
  data() {
    return {
      submitPressed: false,
      registerPressed: false,
      _lastReleaseAt: 0,
      _lastRegisterTipAt: 0,
      formErr: {
        userName: false,
        mobile: false,
        email: false,
        companyName: false
      },
      signMsg: {
        companyName: '',
        mobile: '',
        email: '',
        userName: ''
      },
      formErrMsg: {
        companyName: '请输入单位名称',
        mobile: '请输入联系电话',
        email: '请输入邮箱地址',
        userName: '请输入联系人'
      },
      modalVisible: false,
      tipVisible: false,
      tipMessage: ''
    }
  },
  methods: {
    onPress() {
      this.submitPressed = true;
    },
    onRelease() {
      // guard against duplicate release events (touch -> synthetic mouse) by time-based dedupe
      const now = Date.now();
      if (now - (this._lastReleaseAt || 0) < 350) {
        return;
      }
      this._lastReleaseAt = now;
      // small timeout to keep the pressed feedback visible for a short moment on quick taps
      setTimeout(() => {
        this.submitPressed = false;
        this.clickSubmit();
      }, 100);
    },
    onRegisterPress() {
      this.registerPressed = true;
    },
    onRegisterRelease() {
      setTimeout(() => {
        this.registerPressed = false;
      }, 100);
    },
    onRegisterReleaseAndShow() {
      // ensure visual feedback shows briefly before opening modal
      setTimeout(() => {
        this.registerPressed = false;
        this.showRegistrationClosedTip();
      }, 80);
    },
    touchMove(e) {
      e.preventDefault();
    },
    showModal() {
      this.modalVisible = true;
      document.addEventListener('touchmove', this.touchMove, { passive: false });
    },
    hideModal() {
      this.modalVisible = false;
      this.formErr = {
        userName: false,
        mobile: false,
        email: false,
        companyName: false
      };
      this.formErrMsg = {
        mobile: '请输入联系电话',
        email: '请输入邮箱地址',
        userName: '请输入联系人',
        companyName: '请输入单位名称'
      };
      this.signMsg = {
        mobile: '',
        email: '',
        userName: '',
        companyName: ''
      };
      document.removeEventListener('touchmove', this.touchMove);
    },
    showTip(message) {
      this.tipMessage = message || '';
      this.tipVisible = true;
      document.addEventListener('touchmove', this.touchMove, { passive: false });
    },
    hideTip() {
      this.tipVisible = false;
      this.tipMessage = '';
      document.removeEventListener('touchmove', this.touchMove);
    },
    clickSubmit() {
      let nextFlag = true;
      for (let key in this.signMsg) {
        const str = this.signMsg[key];
        if (!str) {
          this.formErr[key] = true;
          nextFlag = false;
          switch (key) {
            case 'mobile':
              this.formErrMsg[key] = '请输入联系电话';
              break;
            case 'email':
              this.formErrMsg[key] = '请输入邮箱地址';
              break;
          }
        } else {
          if (key === 'mobile') {
            const reg = /^1[3-9]\d{9}$/;
            if (reg.test(str)) {
              this.formErr[key] = false;
            } else {
              nextFlag = false;
              this.formErr[key] = true;
              this.formErrMsg[key] = '电话号码格式不正确';
            }
          } else if (key === 'email') {
            const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (reg.test(str)) {
              this.formErr[key] = false;
            } else {
              nextFlag = false;
              this.formErr[key] = true;
              this.formErrMsg[key] = '邮箱格式不正确';
            }
          } else {
            this.formErr[key] = false;
          }
        }
      }
      if (nextFlag) {
        this.saveUserInfo();
      }
    },
    showRegistrationClosedTip() {
      const now = Date.now();
      if (now - (this._lastRegisterTipAt || 0) < 350) {
        return;
      }
      this._lastRegisterTipAt = now;
      this.showTip('报名已结束！');
    },
    saveUserInfo() {
      this.$http.saveUserInfo(this.signMsg).then(res => {
        this.hideModal();
        this.showTip('报名成功');
      });
    }
  }
}
</script>

<style scoped lang="less">

  .green-finance-award {
    background-color: #2d6675;
    margin-bottom: -52px;

    .award-image-container {
      position: relative;
      width: 100%;
      display: block;
    }

    .award-main-image {
      width: 100%;
      height: auto;
      display: block;
    }

    .register-button-overlay {
      position: absolute;
      /* award_2026.jpg (750×8287): 立即报名 button ≈ (160,1782)-(589,1815), incl. rounded corners */
      left: 21.3%;
      right: 21.5%;
      top: 19.82%;
      height: 0.80%;
      cursor: pointer;
      z-index: 1;
      // background: red;
      /* Add a subtle hover/press effect for better UX */
      transition: background-color 120ms ease, transform 120ms ease;
      border-radius: 4px;

      &:hover {
        background-color: rgba(255, 255, 255, 0.06);
      }

      &.pressed {
        background-color: rgba(255, 255, 255, 0.16);
        transform: scale(0.998);
      }
    }

    .modal {
      .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: #00000070;
      }

      .modal-wrap {
        width: 335px;
        height: 468px;
        position: fixed;
        top: calc((100vh - 468px) / 2);
        left: calc((100vw - 335px) / 2);
        z-index: 2;

        .modal-box {
          position: relative;
          padding-top: 160px;
          width: 100%;
          height: 100%;
          overflow: hidden;
          border-radius: 6px;
          background-image: url("../../assets/mobile/award/modal-bg-2026.png");
          background-size:100% auto;
          background-repeat: no-repeat;
          background-position: top center;

          >p {
            width: 236px;
            margin: 20px auto 10px;
            color: #1d1d1d;
            font-size: 12px;
            line-height: 18px;
          }

          .form {
            width: 236px;
            margin: 0 auto;

            .item {
              .inp-wrap {
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 2px;

                *> {
                  display: inline-block;
                  vertical-align: middle;
                }

                .label {
                  text-align: justify;
                  height: 20px;
                  width: 57px;
                  color: #1d1d1d;

                  &:after {
                    content: "";
                    display: inline-block;
                    width: 100%;
                  }
                }

                input {
                  caret-color: #1d1d1d;
                  box-sizing: border-box;
                  width: 164px;
                  margin-left: 15px;
                  border: 1px solid #DDDDDD;
                  background: transparent;
                  border-radius: 2px;
                  height: 24px;
                  font-size: 12px;
                  color: #1d1d1d;
                  padding: 5px 10px;
                }
              }

              .err-msg {
                text-align: right;
                font-size: 12px;
                color: #f00;
              }
            }
          }

          .submit-btn {
            width: 105px;
            height: 27px;
            background: linear-gradient(to right, #9cce84, #3db57e);
            color: #fff;
            text-align: center;
            line-height: 27px;
            font-size: 16px;
            margin: 10px auto;
            border-radius: 5px;
            /* make button respond visually when pressed */
            transition: transform 120ms ease, filter 120ms ease, box-shadow 120ms ease;
            -webkit-tap-highlight-color: transparent; /* avoid default mobile highlight */
            user-select: none;
          }

          .submit-btn.pressed {
            filter: brightness(0.92);
            transform: scale(0.98);
            box-shadow: inset 0 2px 6px rgba(0,0,0,0.15);
          }
        }

        .close-btn {
          background: #ffffff60;
          color: #fff;
          font-size: 18px;
          width: 28px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          border-radius: 50%;
          position: absolute;
          right: -3px;
          top: -3px;
        }
      }
    }

    /* 成功提示弹窗样式 */
    .tip-modal {
      .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: #00000070;
        z-index: 10;
      }

      .tip-wrap {
        width: 280px;
        position: fixed;
        top: calc((100vh - 180px) / 2);
        left: calc((100vw - 280px) / 2);
        z-index: 11;

        .tip-box {
          width: 100%;
          background: #fff;
          border-radius: 8px;
          padding: 16px 16px 12px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.12);

          .tip-title {
            color: #1d1d1d;
            font-size: 16px;
            font-weight: 600;
            text-align: center;
          }

          .tip-message {
            margin: 10px 0 14px;
            color: #333;
            font-size: 14px;
            text-align: center;
            line-height: 20px;
          }

          .ok-btn {
            width: 100%;
            height: 34px;
            line-height: 34px;
            text-align: center;
            color: #fff;
            background: linear-gradient(to right, #9cce84, #3db57e);
            border-radius: 6px;
            user-select: none;
            -webkit-tap-highlight-color: transparent;
          }
        }
      }
    }
  }

</style>